// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCardSummary_container__WXd8e","imageContainer":"CustomCardSummary_imageContainer__Tp__t"};